var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-mit-volume-analytics-time"},[_c('v-card',{attrs:{"flat":""}},[_c('v-row',{staticClass:"pa-4",attrs:{"justify":"space-between"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{attrs:{"flat":""}},[_c('canvas',{attrs:{"id":_vm.chartId}})])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }